import React from 'react';

export const GenerateImageContext = React.createContext({});

